class ProductDetailImages extends Component {
	constructor(el) {
		super(el);
		this.swiperEl = this.$find('[data-swiper-detail]');
		this.init();
	}

	constructSwiper() {
		this.thumbsSwiper = new Swiper(this.swiperEl, {
			lazy:  {
				loadPrevNext: true
			},
			navigation: {
				nextEl: '[data-swiper-detail-next]',
				prevEl: '[data-swiper-detail-prev]',
			},
			centeredSlides: true,
			slidesPerView: 2,
			spaceBetween: 15,
			initialSlide: 0,
			breakpoints: {
				320: {
					slidesPerView: 1
				},
				992: {
					slidesPerView: 2,
					initialSlide: 1
				},
				2050: {
					slidesPerView: 3,
					initialSlide: 1
				},
				3050: {
					slidesPerView: 4,
					initialSlide: 1
				},
			}
		});
	}

	init() {
		this.swiperEl && this.constructSwiper();
	}
}
